<template>
	<FormulateInput
		v-if="!$auth.user || ($auth.user && !$auth.user.loyalty_id)"
		class="col-12 px-0 mb-3 small"
		type="checkbox"
		name="registerLoyalty"
		data-action="panels-agreement-input-loyalty-registration-agreement"
		:validation="`${required ? 'required' : ''}`"
		:validation-messages="{
			'required': 'обязательно к заполнению',
		}"
		@change="$emit('change', $event.target.checked)"
	>
		<template #label="{ id }">
			<label :for="id" class="ml-2">
				{{ $t('submitAgreementShort') }} {{ $t('acceptLoyality') }}
				<a
					:href="`https://sk.skolkovo.ru/storage/loyality_legal.pdf`"
					target="_blank"
				>
					{{ $t('agreementLoyality') }}
				</a>
			</label>
		</template>
	</FormulateInput>
</template>

<script>
export default {
	name: 'LoyaltyRegistrationInput',
	props: {
		required: { type: Boolean, default: false },
	},
};
</script>

<style scoped>

</style>
